import PartnershipLinksBlock from './PartnershipLinksBlock';

export default PartnershipLinksBlock;
